module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', [_vm._v("Nombre")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.booking.customer.data.name) + "\n\t\t\t\t" + _vm._s(_vm.booking.customer.data.lastname) + "\n\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "px-0": ""
    }
  }, [_c('p', [_vm._v("Celular")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.phoneData))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNúmero de Noches:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.numberNights))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFecha de reserva:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNúmero de Huéspedes:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.guestNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFuentes:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.channel))])])])])])], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "customer": _vm.booking.customer.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b328a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/calendar/Prepayment.vue
// module id = 1639
// module chunks = 75